import { Component } from '@angular/core';
import {Observable} from "rxjs";
import {ApiService, OverviewMetrics} from "../../../services/api.service";
import {QuickCardComponent} from "../../../core/quick-card/quick-card.component";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'users-quick-card',
  standalone: true,
  imports: [
    QuickCardComponent,
    MatTooltipModule
  ],
  templateUrl: './users-quick-card.component.html',
})
export class UsersQuickCardComponent {
  loader?: Observable<OverviewMetrics>

  constructor(readonly api:ApiService) {}

  ngOnInit(): void {
    this.loader = this.api.getUsersOverview()
  }
}
